import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('link')

import Utils from "@/helpers/utils.js";

export default {
  namespaced: true,
  state: {
    link: {},
  },
  mutations: {
    setLink: (state, data) => { 
      data['contents'] = data['contents'].replace(/(?:\r\n|\r|\n)/g, '<BR/>')
      state.link = data
    }
  },
  actions: {
    getLinks: async ({commit}, target) => {
      try {
        console.log(target)
        const response = await api.get(`link/target/${target}`)
        // console.log("links :", response.data)
        commit('setLink', response.data)
      } catch (e) {
        console.error('[axios] getLinks :', e.message)
      }
    }
  }
}